import * as React from 'react';
import { css } from 'office-ui-fabric-react/lib/Utilities';
import * as FieldStyles from '../Field.scss';

/**
 * @public
 */
export interface IBaseTextProps extends React.HTMLProps<HTMLDivElement> {
  /** Text to render */
  text: string;

  /** Apply special styling if an item is diabled */
  isDisabled?: boolean;

  /** If set, no text is rendered */
  noTextRender?: boolean;

  /** Text to put in aria-label. If not specified, defaults to rendered text */
  ariaLabel?: string;

  /** Text for the title property, which determines the tooltip text. */
  title?: string;
}

/**
 * @public
 */
export const BaseText: React.StatelessComponent<IBaseTextProps> = (props: IBaseTextProps) => {
  const {
    text,
    isDisabled,
    noTextRender,
    ariaLabel,
    title,
    children,
    ...divProps
  } = props;

  if (!children && (noTextRender || !text)) {
    return null;  // save dom elements when it has nothing to render.
  }

  return (
    <div
      { ...divProps }
      aria-label={ noTextRender ? (ariaLabel || text) : undefined }
      title={ title }
      className={ css(props.className, { [`${FieldStyles.disabledField}`]: isDisabled }) }
    >
      { (!noTextRender && text) }
      { children }
    </div>
  );
};
